<template>
  <div class="user-info-card">
    <!-- <div class="card-header">
      <span class="header-title">个人信息</span>
    </div> -->
    
    <div class="card-content">
      <!-- 头像区域 -->
      <div class="avatar-section">
        <el-avatar 
          :size="120" 
          :src="userInfo.avatar"
          class="user-avatar"
        >
          {{ userInfo.username ? userInfo.username.charAt(0) : 'U' }}
        </el-avatar>
        
        <!-- <div class="avatar-actions">
          <el-upload
            class="avatar-uploader"
            action="/api/upload/avatar"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
          >
            <el-button type="primary" size="small">更换头像</el-button>
          </el-upload>
        </div> -->

        
      </div>
      
      <!-- 信息展示区域 -->
      <div class="info-section">
        <div class="info-row">
          <span class="info-label">用户名：</span>
          <span class="info-value">{{ userInfo.username || '未设置' }}</span>
        </div>
        
        <div class="info-row">
          <span class="info-label">工号：</span>
          <span class="info-value">{{ userInfo.userCode || '未设置' }}</span>
        </div>
        
        <div class="info-row">
          <span class="info-label">部门：</span>
          <span class="info-value">{{ userInfo.department || '未设置' }}</span>
        </div>
        
        <div class="info-row">
          <span class="info-label">权限：</span>
          <span class="info-value">
            <el-tag 
              :type="userInfo.isAdmin ? 'danger' : 'info'"
              size="small"
            >
              {{ userInfo.isAdmin ? '管理员' : '普通用户' }}
            </el-tag>
          </span>
        </div>            
      </div>
    </div>  
  </div>
</template>

<script>
export default {
  name: 'UserInfoCard',
  props: {
    userInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      editDialogVisible: false,
      saving: false,
      editForm: {
        username: '',
        department: ''
      },

    };
  },
  methods: {
    handleEdit() {
      this.editForm = { ...this.userInfo };
      this.editDialogVisible = true;
    },
    
    handleSave() {
      this.$refs.editFormRef.validate(async (valid) => {
        if (valid) {
          this.saving = true;
          try {
            await this.$emit('update-user-info', this.editForm);
            this.editDialogVisible = false;
          } finally {
            this.saving = false;
          }
        }
      });
    },
    
    handleDialogClose() {
      this.$refs.editFormRef.clearValidate();
    },
    
    handleAvatarSuccess(response) {
      if (response.code === 200) {
        this.userInfo.avatar = response.data.url;
        this.$message.success('头像上传成功');
      } else {
        this.$message.error('头像上传失败: ' + response.message);
      }
    },
    
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;
      
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG/PNG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      
      return isJPG && isLt2M;
    }
  }
};
</script>

<style scoped lang="scss">
// 主色调定义
$primary-color: rgba(37, 100, 207, 0.8);
$primary-color-dark: rgba(29, 80, 165, 1);
$primary-color-light: rgba(37, 100, 207, 0.6);
$white: #FFFFFF;
$border-color: rgba(255, 255, 255, 0.2);
$shadow-color: rgba(37, 100, 207, 0.3);
$hover-color: rgba(29, 80, 165, 0.9);


.user-info-card {
  background: $primary-color;
      align-items: center;

  border-radius: 12px;
  box-shadow: 0 4px 20px $shadow-color;
  margin-bottom: 20px;
  overflow: hidden;
  border: 1px solid $border-color;
  transition: all 0.3s ease;
    // min-width: 450px;

  
  .card-content {
    padding: 20px 20px;
    display: flex;
    // flex-wrap: wrap;   /* 【核心原因】: 此行导致换行 */
    align-items: center;
  }
  
  .avatar-section {
    width: 20%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-right: 50px;
    
    .user-avatar {
      // margin-bottom: 20px; /* 有修改头像的按钮时有点用 */
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      transition: all 0.3s ease;
      font-size: 36px !important;    /* 增大字体 */
      font-weight: regular;             /* 字体加粗 */
      color: white !important;  /* 确保文字是白色 */
      // background-color: #409EFF; /* 如果没有头像时的背景色 */
    }
  }
  
  .info-section {
    flex: 1;
    
    
    .info-row {
      margin-bottom: 15px;
      display: flex;
      align-items: center;
      
      &:last-child {
        margin-bottom: 0;
      }
      
      .info-label {
        width: 80px;
        color: rgba(255, 255, 255, 1);
        font-weight: bold;
      }
      
      .info-value {
        flex: 1;
        color: rgba(255, 255, 255, 1);

      }
    }
  }
  
  .actions-section {
    width: 100%;
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px solid #f5f7fa;
    display: flex;
    justify-content: center;
  }

  /* ✅ 手机端：头像适当缩小（默认 120px → 56px），并收紧留白 */
  @media screen and (max-width: 768px) {
    .card-content {
      padding: 12px 12px;
    }

    .avatar-section {
      width: auto !important;
      margin-right: 14px !important;

      /* el-avatar 的 size 是行内样式，必须 !important 覆盖 */
      ::v-deep .el-avatar,
      ::v-deep .user-avatar {
        width: 56px !important;
        height: 56px !important;
        line-height: 56px !important;
        font-size: 22px !important;   /* 没头像时显示的首字母 */
      }
    }

    .info-section .info-row {
      margin-bottom: 10px;

      .info-label {
        width: 60px;
        font-size: 13px;
      }

      .info-value {
        font-size: 13px;
      }
    }
  }
}
</style>